import { createContext } from 'react';
// DOM node in the step header where the wizard's top NEXT/PREVIOUS buttons are portalled.
// Provided by the wizard layout; null (default) means no top slot is mounted, so the top
// buttons simply aren't rendered (e.g. in isolated unit tests of Actions).
export var WizardTopActionsSlotContext = createContext(null);